(function() { 'use strict';
    angular.module('mso.registration')
        .controller('RegisterSuccessCtrl', RegisterSuccessCtrl);

    RegisterSuccessCtrl.$inject = ['referenceData'];
    function RegisterSuccessCtrl (referenceData){
        var vm = this;

        vm.vs = referenceData.valuesets;
        vm.messages = referenceData.messages;
        vm.parameters = referenceData.parameters;
    }
})();
